export function currentTurnReview(items = []) {
  const timeline = Array.isArray(items) ? items : [];
  let latestParticipantIndex = -1;

  for (let index = timeline.length - 1; index >= 0; index -= 1) {
    const item = timeline[index];
    if (item?.kind === "msg" && item?.sender === "participant") {
      latestParticipantIndex = index;
      break;
    }
  }

  const currentTurnItems = timeline.slice(latestParticipantIndex + 1);
  const edits = currentTurnItems.filter((item) => item?.kind === "edit");
  if (!edits.length) {
    return { edits: [], beforeMessageId: null };
  }

  const lastEditIndex = currentTurnItems.reduce(
    (latest, item, index) => item?.kind === "edit" ? index : latest,
    -1
  );
  const followingMessage = currentTurnItems
    .slice(lastEditIndex + 1)
    .find((item) => item?.kind === "msg");

  return {
    edits,
    beforeMessageId: followingMessage?.id || null,
  };
}
